import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./LotTable.module.css";
import {
  InfoCircleOutlined,
  CloseCircleOutlined,
  QuestionOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Tag,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  cancelBilApi,
  checkDoneLot,
  checkEmpty,
  getAboutLot,
  getCurrentDateUtil,
  getDateUtilYYYY,
  getDateUtilYYYYTime,
  getLotResultByOrderLot,
  getPriceDetail,
  getRrderDetails,
  getToken,
  isAdmin,
  numberWithCommas,
  parseJwt,
  pathRoutes,
  rmBilApi,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import Countdown from "react-countdown";
import LoadingCenter from "../main/LoadingCenter";
const { confirm } = Modal;

function LotTableV2(props) {
  const appContext = useContext(AppContext);
  const [openModal, setOpenModal] = useState(false);
  const [orders, setOrders] = useState(
    parseInt(props.index) > 10 ? null : props.orders
  );
  const [ordersTemp, setOrdersTemp] = useState(props.orders);
  const [orderAc, setOrderAc] = useState({});
  const [sumPrice, setSumPrice] = useState(0);
  const [sumPriceNumber, setSumPriceNumber] = useState(0);
  const [cancelOrderIds, setCancelOrderIds] = useState([]);
  const [rmOrderIds, setRmOrderIds] = useState([]);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  // useEffect(() => {
  //   let ordersUse = [];
  //   for (let a = 0; a < props.orders?.length; a++) {
  //     if (props.orders[a].lot_id == props.lot.lot_id) {
  //       ordersUse.push(props.orders[a]);
  //     }
  //   }
  //   setOrders(ordersUse);
  //   // console.log("ordersUse", ordersUse);
  // }, []);

  const getCreateDate = (order) => {
    return getDateUtilYYYYTime(order?.last_order);
  };

  const getLotDate = (order) => {
    return getDateUtilYYYY(order?.lot_date);
  };

  const getPrice = (order, color) => {
    return (
      <div style={{ color: color }}>
        {numberWithCommas(order?.total_price_multi)}
      </div>
    );
  };

  const getStatusV = (order) => {
    if (cancelOrderIds.includes(order?.lot_order_id) || order?.status == "N")
      return "";
    let res = { status: "none", text: "" };

    let color = "";
    if (checkEmpty(order?.lot_top)) {
      res.text = "";
      return "";
    }

    if (parseInt(order?.done_price) > 0) {
      color = "green";
      res.text = numberWithCommas(order?.done_price);
    } else {
      res.text = "ไม่ถูกรางวัล";
      color = "red";
    }

    return color;
  };
  const getStatus = (order) => {
    if (cancelOrderIds.includes(order?.lot_order_id) || order?.status == "N")
      return <div style={{ color: "black" }}>{"ยกเลิกเเล้ว"}</div>;
    let res = { status: "none", text: "" };

    let color = "";
    if (checkEmpty(order?.lot_top)) {
      res.text = "";
      return <div style={{ color: color }}>{res.text}</div>;
    }

    if (parseInt(order?.done_price) > 0) {
      color = "green";
      res.text = numberWithCommas(order?.done_price);
    } else {
      res.text = "ไม่ถูกรางวัล";
      color = "red";
    }

    return <div style={{ color: color }}>{res.text}</div>;
  };

  const getLotType = () => {
    // return `[${props.lot.lot_type}] ${props.lot.lot_name}`;
    return `${props.lot?.lot_name}`;
  };
  const getRemark = (order) => {
    return <div style={{ color: "blue" }}>{order?.remark}</div>;
  };

  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    if (isAdmin()) {
      setAdmin(true);
    }
  }, []);

  const getDatail = (order) => {
    return (
      <>
        {!cancelOrderIds.includes(order?.lot_order_id) &&
          order?.status != "N" && (
            <CloseCircleOutlined
              // width={"1em"}
              style={{ color: "red" }}
              className={styles.iconmore}
              onClick={() => {
                confirm({
                  title: "ยกเลิก",
                  icon: <QuestionOutlined />,
                  content: "ยืนยันยกเลิกหวยนี้",
                  okText: "ยืนยัน",
                  // okType: 'danger',
                  cancelText: "ยกเลิก",
                  onOk() {
                    console.log("OK");
                    cancelBil(order);
                  },
                  onCancel() {
                    console.log("Cancel");
                  },
                });
              }}
            />
          )}
        {(cancelOrderIds.includes(order.lot_order_id) ||
          order?.status == "N") && (
          <DeleteOutlined
            // width={"1em"}
            style={{ color: "red" }}
            className={styles.iconmore}
            onClick={() => {
              confirm({
                title: "ลบ",
                icon: <QuestionOutlined />,
                content: "ยืนยันลบหวยนี้",
                okText: "ยืนยัน",
                // okType: 'danger',
                cancelText: "ยกเลิก",
                onOk() {
                  console.log("OK");
                  rmBil(order);
                },
                onCancel() {
                  console.log("Cancel");
                },
              });
            }}
          />
        )}

        <InfoCircleOutlined
          // width={"2em"}
          className={styles.iconmore}
          style={{ color: "blue", paddingLeft: "15px" }}
          onClick={() => {
            setOrderAc(order);
            setOpenModal(true);
          }}
        />
      </>
    );
  };

  const cancelBil = async (order) => {
    try {
      let body = {
        lot_order_id: order?.lot_order_id,
      };
      await cancelBilApi(body);
      let ordersids = cancelOrderIds;
      ordersids.push(order?.lot_order_id);
      setCancelOrderIds(Object.assign([], ordersids));
    } catch (e) {}
  };

  const rmBil = async (order) => {
    try {
      let body = {
        lot_order_id: order?.lot_order_id,
      };
      await rmBilApi(body);
      let ordersids = rmOrderIds;
      ordersids.push(order?.lot_order_id);
      setRmOrderIds(Object.assign([], ordersids));
    } catch (e) {}
  };

  const columns = [
    {
      title: "ประเภท @ หมายเลข",
      dataIndex: "type_num",
      key: "type_num",
      // render: (text) => <span style={{ color: "black" }}>{text}</span>,
      render: (_, { type_num }) => (
        <>
          <span
            style={{ color: "black", fontWeight: type_num.fontWeight }}
            className=""
          >
            {type_num.text}
          </span>
        </>
      ),
    },
    {
      title: "ยอด",
      dataIndex: "price",
      key: "price",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { price }) => (
        <>
          <span style={{ color: "green", fontWeight: price.fontWeight }}>
            {price.text}
          </span>
        </>
      ),
    },
    {
      title: "จ่าย",
      dataIndex: "pay",
      key: "pay",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { pay }) => (
        <>
          <span style={{ color: "blue", fontWeight: pay.fontWeight }}>
            {pay.text}
          </span>
        </>
      ),
    },
    {
      title: "รวม",
      key: "total",
      dataIndex: "total",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { total }) => (
        <>
          <span style={{ color: "green", fontWeight: total.fontWeight }}>
            {total.text}
          </span>
        </>
      ),
    },
    ,
    {
      title: "สถานะ",
      key: "status",
      dataIndex: "status",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { status }) => (
        <>
          <span
            className={status.status ? styles.greenColor : ""}
            style={{
              color: status.color,
              paddingRight: "10px",
              fontWeight: status.fontWeight,
            }}
          >
            {status.text}
          </span>
        </>
      ),
    },
  ];

  const [dataOrderDetail, setDataOrderDetail] = useState({});
  const [dataOrderDetails, setDataOrderDetails] = useState([]);
  const [sumPriceOrderDetail, setSumPriceOrderDetail] = useState();
  const [sumPriceTotalOrderDetail, setSumPriceTotalOrderDetail] = useState();
  const [sumPayDoneMain, setSumPayDoneMain] = useState(0);
  const [sumPayDoneMainNumber, setSumPayDoneMainNumber] = useState(0);
  const [loadingModalDetail, setLoadingModalDetail] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  useEffect(() => {
    let user = parseJwt(getToken());
    setUserInfo(user);
    setDataOrderDetail(Object.assign({}, {}));
  }, []);

  const loadOderDetails = async (orderAc) => {
    let orderDetails = null;
    let dataOrderDetailTemp = dataOrderDetail;
    if (checkEmpty(dataOrderDetailTemp[orderAc.lot_order_id])) {
      setDataOrderDetails(Object.assign([], []));
      try {
        setLoadingModalDetail(true);
        orderDetails = await getRrderDetails(orderAc.lot_order_id);
        // console.log("orderDetails", orderDetails);
        let datas = [];
        let priceSum = 0;
        let paySum = 0;
        let payTotal = 0;
        let sumPayDone = 0;
        let priceSumMulti = 0;
        for (let a = 0; a < orderDetails?.length; a++) {
          let detail = orderDetails[a];
          let priceOb = getPriceDetail(detail);
          let price = priceOb?.price;
          priceSum = priceSum + parseInt(price);
          paySum = paySum + parseInt(detail.lot_pay);
          let total = price * parseInt(detail.lot_pay);
          payTotal = payTotal + total;
          let status = "";
          let type_num = "";
          let textTemp = "";
          if ("lot_top_price" == priceOb.type) textTemp = "บน";
          else if ("lot_bottom_price" == priceOb.type) textTemp = "ล่าง";
          else if ("lot_tot_price" == priceOb.type) textTemp = "โต๊ด";
          else if ("lot_run_bottom_price" == priceOb.type)
            textTemp = "วิ่งล่าง";
          else if ("lot_run_top_price" == priceOb.type) textTemp = "วิ่งบน";

          if (detail.lot_sub_type == "lot_2") {
            type_num = "2 ตัว" + textTemp + " @ " + detail.lot_num;
          } else if (detail.lot_sub_type == "lot_3") {
            type_num = "3 ตัว" + textTemp + " @ " + detail.lot_num;
          } else if (detail.lot_sub_type == "lot_run") {
            type_num = textTemp + " @ " + detail.lot_num;
          }

          //**check done***
          let doneColor = "red";
          let doneObject = checkDoneLot(detail, props?.lotResualts);
          // let doneObject ={}

          let statusV = false;
          if (doneObject.status === "done") {
            // if (a == 5) {
            statusV = true;
            doneColor = "green";
            status = "ถูกรางวัล " + numberWithCommas(total);
            sumPayDone = sumPayDone + total;
          } else if (doneObject.status === "fail") {
            status = "ไม่ถูกรางวัล";
          } else {
            status = "";
          }

          if (
            detail.lot_sub_type == "lot_2" &&
            !checkEmpty(userInfo?.user?.multi_price)
          ) {
            priceSumMulti =
              priceSumMulti +
              parseInt(price) * parseInt(userInfo?.user?.multi_price);
          } else {
            priceSumMulti = priceSumMulti + parseInt(price);
          }

          let data = {
            type_num: { text: type_num, fontWeight: "100" },
            price: {
              text: numberWithCommas(parseInt(price)),
              fontWeight: "100",
            },
            pay: {
              text: numberWithCommas(parseInt(detail.lot_pay)),
              fontWeight: "100",
            },
            total: { text: numberWithCommas(total), fontWeight: "100" },
            status: {
              color: doneColor,
              text: status,
              fontWeight: "100",
              status: statusV,
            },
          };
          datas.push(data);
        }

        let data = {
          type_num: {
            text: "รวม @ " + orderDetails?.length + " รายการ",
            fontWeight: "bold",
          },
          price: {
            text: numberWithCommas(parseInt(priceSumMulti)),
            fontWeight: "bold",
          },
          pay: { text: "-", fontWeight: "bold" },
          total: { text: "-", fontWeight: "bold" },
          status: {
            color: "green",
            text: numberWithCommas(sumPayDone),
            fontWeight: "bold",
          },
        };
        datas.push(data);

        // console.log(datas);
        let dataTemp = Object.assign([], datas);
        dataOrderDetailTemp[orderAc.lot_order_id] = dataTemp;
        setDataOrderDetail(dataOrderDetailTemp);
        setDataOrderDetails(Object.assign([], dataTemp));
        setLoadingModalDetail(false);
      } catch (e) {
        setLoadingModalDetail(false);
      }
    } else {
      setDataOrderDetails(Object.assign([], []));
      setDataOrderDetails(
        Object.assign([], dataOrderDetailTemp[orderAc.lot_order_id])
      );
    }
  };

  useEffect(() => {
    if (!openModal) return;
    loadOderDetails(orderAc);
  }, [orderAc, openModal]);

  useEffect(() => {
    let sumPayDone = 0;
    for (let b = 0; b < ordersTemp?.length; b++) {
      let orderAc = ordersTemp[b];
      if (
        cancelOrderIds.includes(orderAc.lot_order_id) ||
        orderAc.status == "N"
      ) {
        continue;
      }
      sumPayDone += parseInt(orderAc.done_price);
    }
    // if (!sumPayDone == 0)
    setSumPayDoneMain(numberWithCommas(sumPayDone));
    setSumPayDoneMainNumber(sumPayDone);
    // appContext.setSumPricePayDone(appContext.sumPricePayDone + sumPayDone);
  }, [ordersTemp, cancelOrderIds]);

  useEffect(() => {
    let sumPriceTemp = 0;
    for (let a = 0; a < ordersTemp?.length; a++) {
      // if (ordersTemp[a].status == "N") continue;
      if (
        cancelOrderIds.includes(ordersTemp[a].lot_order_id) ||
        ordersTemp[a].status == "N"
      ) {
        continue;
      }
      sumPriceTemp = sumPriceTemp + parseInt(ordersTemp[a].total_price_multi);
    }
    setSumPrice(numberWithCommas(sumPriceTemp));
    setSumPriceNumber(sumPriceTemp);
    // appContext.setSumPrice(appContext.sumPrice + sumPriceTemp);
    console.log("appContext.sumPrice", appContext.sumPrice);
  }, [ordersTemp, cancelOrderIds]);

  const getTitileCollapse = () => {
    let text = "[" + props.lot.lot_type + "]" + " " + props.lot.lot_name;
    let sum = parseInt(sumPriceNumber) - parseInt(sumPayDoneMainNumber);
    let color = "green";
    if (sum < 0) {
      color = "red";
    }

    return (
      <span>
        {text}
        <span style={{ color: color, paddingLeft: "5px", fontSize: "15px" }}>
          ({numberWithCommas(sum)})
        </span>
      </span>
    );
  };
  const [activeKey, setActiveKey] = useState(
    parseInt(props.index) > 10 ? "" : "1"
  );

  return (
    <div className={styles.boxLotType}>
      {/* <div className={styles.headerType}>
        {"[" + props.lot.lot_type + "]" + " " + props.lot.lot_name}
      </div> */}

      <Collapse
        className={styles.CollapseLot}
        defaultActiveKey={activeKey}
        activeKey={activeKey}
        onChange={() => {
          if (orders == null) setOrders(ordersTemp);
          if (activeKey == "1") setActiveKey("");
          else setActiveKey("1");
        }}
        items={[
          {
            key: "1",
            label: getTitileCollapse(),
            children: (
              <div>
                <div className={styles.pcboxsumary}>
                  <Row className={styles.rowHeader}>
                    <Col span={4} className={styles.columnHeaderTable}>
                      วันที่
                    </Col>
                    <Col span={3} className={styles.columnHeaderTable}>
                      ชนิดหวย
                    </Col>
                    <Col span={3} className={styles.columnHeaderTable}>
                      ชื่องวด
                    </Col>
                    <Col span={3} className={styles.columnHeaderTable}>
                      ยอด
                    </Col>
                    {/* <Col span={3} className={styles.columnHeaderTable}>
          รวม
        </Col> */}
                    <Col span={3} className={styles.columnHeaderTable}>
                      เเพ้/ชนะ
                    </Col>
                    <Col span={4} className={styles.columnHeaderTable}>
                      หมายเหตุ
                    </Col>
                    <Col span={4} className={styles.columnHeaderTable}></Col>
                  </Row>
                  {orders?.map((order) => {
                    if (rmOrderIds.includes(order?.lot_order_id)) {
                      return;
                    }

                    return (
                      <div>
                        <Row
                          className={[
                            styles.rowTable,
                            getStatusV(order) == "green"
                              ? styles.statusDone
                              : "",
                          ].join(" ")}
                        >
                          <Col span={4} className={styles.columnTable}>
                            {getCreateDate(order)}
                          </Col>
                          <Col span={3} className={styles.columnTable}>
                            {getLotType()}
                          </Col>
                          <Col span={3} className={styles.columnTable}>
                            {getLotDate(order)}
                          </Col>
                          <Col span={3} className={styles.columnTable}>
                            {getPrice(order, "green")}
                          </Col>
                          {/* <Col span={3} className={styles.columnTable}>
                {getPrice(order, "blue")}
              </Col> */}
                          <Col span={3} className={styles.columnTable}>
                            {getStatus(order)}
                          </Col>
                          <Col span={4} className={styles.columnTable}>
                            {getRemark(order)}
                          </Col>
                          <Col span={4} className={styles.columnTable}>
                            {(admin || true) &&
                              "" + order.admin_nickname + " : "}
                            {getDatail(order)}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                  <Row className={styles.rowFooter}>
                    <Col span={10} className={styles.columnFooterTable}>
                      รวม
                    </Col>
                    <Col span={3} className={styles.columnFooterTable}>
                      {sumPrice}
                    </Col>
                    {/* <Col span={3} className={styles.columnFooterTable}>
          {sumPrice}
        </Col> */}
                    <Col span={3} className={styles.columnFooterTable}>
                      {sumPayDoneMain}
                    </Col>
                    <Col span={4} className={styles.columnFooterTable}></Col>
                    <Col span={4} className={styles.columnFooterTable}></Col>
                  </Row>
                </div>

                <div className={styles.mobileboxsumary}>
                  <Row className={styles.rowHeader}>
                    <Col span={7} className={styles.columnHeaderTable}>
                      วันที่
                    </Col>
                    <Col span={5} className={styles.columnHeaderTable}>
                      ยอด
                    </Col>
                    <Col span={6} className={styles.columnHeaderTable}>
                      เเพ้/ชนะ
                    </Col>
                    <Col span={6} className={styles.columnHeaderTable}>
                      หมายเหตุ
                    </Col>
                    {/* <Col span={4} className={styles.columnHeaderTable}></Col> */}
                  </Row>
                  {orders?.map((order) => {
                    return (
                      <div
                        onClick={() => {
                          setCurrentOrder(order);
                          setShowModalDetail(true);
                        }}
                      >
                        <Row
                          className={[
                            styles.rowTable,
                            getStatusV(order) == "green"
                              ? styles.statusDone
                              : "",
                          ].join(" ")}
                        >
                          <Col span={7} className={styles.columnTable}>
                            {getCreateDate(order)}
                          </Col>
                          <Col span={5} className={styles.columnTable}>
                            {getPrice(order, "green")}
                          </Col>
                          <Col span={6} className={styles.columnTable}>
                            {getStatus(order)}
                          </Col>
                          <Col span={6} className={styles.columnTable}>
                            {getRemark(order)}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                  <Row className={styles.rowFooter}>
                    <Col span={6} className={styles.columnFooterTable}>
                      รวม
                    </Col>
                    <Col span={6} className={styles.columnFooterTable}>
                      {sumPrice}
                    </Col>
                    <Col span={6} className={styles.columnFooterTable}>
                      {sumPayDoneMain}
                    </Col>
                    <Col span={6} className={styles.columnFooterTable}></Col>
                  </Row>
                </div>
              </div>
            ),
          },
        ]}
        // onChange={(e) => {}}
      />

      <Modal
        title="รายละเอียด"
        centered
        open={openModal}
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        // style={{ width: "100%" }}
        width={1000}
        className={styles.modalOrderDetail}
      >
        {openModal && (
          <>
            {loadingModalDetail ? (
              <div style={{ height: "20px" }}>
                <div className={styles.centerLoadingContent}>
                  <Spin tip="Loading" size="large">
                    <div className="content" />
                  </Spin>
                </div>
              </div>
            ) : (
              <Table
                className={styles.tablemodal}
                columns={columns}
                dataSource={dataOrderDetails}
                pagination={false}
                rowClassName={styles.rowClass}
              />
            )}
          </>
        )}
      </Modal>

      <Modal
        title="รายละเอียด"
        centered
        open={showModalDetail}
        onOk={() => setShowModalDetail(false)}
        onCancel={() => setShowModalDetail(false)}
        style={{ width: "100%" }}
        footer={[
          <Button
            key="OK"
            type="primary"
            onClick={() => {
              setShowModalDetail(false);
            }}
          >
            ปิด
          </Button>,
        ]}
      >
        {showModalDetail && (
          <div>
            <div>
              <div className={styles.headerdetail}>ชื่องวด</div>
              <div>{getLotDate(currentOrder)}</div>
            </div>
            <div>
              <div className={styles.headerdetail}>คนลงหวย</div>
              <div>{currentOrder?.admin_nickname}</div>
            </div>
            <div>
              <div className={styles.headerdetail}>เพิ่มเติม</div>
              <div style={{ paddingTop: "10px" }}>
                {getDatail(currentOrder)}
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
export default LotTableV2;
